import { IImageMedia } from 'modules/common/interfaces';
import { useMemo } from 'react';
import { LogisticProvider } from 'modules/inventory/provider/common/constants';
import { AvatarMedia } from 'components/AvatarMedia';
import { Box } from '@mui/material';
import { LOGISTIC } from 'modules/inventory/constants/entities.style';
import IconBox from './IconBox';
import { ProviderIcon } from 'modules/inventory/common/components/Icons/ProviderIcon';

type ProviderAvatarCellProps = {
  image?: IImageMedia;
  type?: string;
  variant?: 'circular' | 'rounded' | 'square';
  name: string;
};

const ProviderAvatarCell = ({ image, type, variant, name }: ProviderAvatarCellProps) => {
  const isLogistic = useMemo(() => type === LogisticProvider, [type]);

  return (
    <Box position={'relative'}>
      <AvatarMedia name={name} avatar={image} variant={variant}>
        <ProviderIcon fontSize='small' />
      </AvatarMedia>
      {isLogistic && <IconBox icon={LOGISTIC.ICON} top={-10} right={-2} />}
    </Box>
  );
};

export default ProviderAvatarCell;
